<template>
	<AccordionItem :defaultOpen="open">
		<template #trigger>
			{{ name }}
		</template>
		<slot />
	</AccordionItem>
</template>

<script lang="ts">
import { AccordionItem } from "@soft-db/ui";
import { defineComponent } from "vue";

export default defineComponent({
	name: "PanelConfigurationSection",
	components: { AccordionItem },
	props: {
		name: String,
		open: Boolean,
	},
	setup() {
		return {};
	},
});
</script>
